import React from "react";

const SignUpContext = React.createContext();

const SignUpProvider = SignUpContext.Provider
const SignUpConsumer = SignUpContext.Consumer

export { SignUpProvider, SignUpConsumer }